import { useState, useEffect, useCallback, useRef } from 'react';
export const useModalObserver = ({ isModalOpen, }) => {
    const [isIntersectingViewport, setIntersected] = useState(false);
    const [isObserverStarted, setObserverStarted] = useState(false);
    const modalObserverRef = useRef(null);
    useEffect(() => {
        modalObserverRef.current = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.intersectionRatio !== 1) {
                    setIntersected(true);
                }
                else {
                    setIntersected(false);
                }
            });
        }, { threshold: 1 });
        return () => { var _a; return (_a = modalObserverRef.current) === null || _a === void 0 ? void 0 : _a.disconnect(); };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const dialogContentRef = useCallback((node) => {
        var _a, _b, _c, _d;
        if (isModalOpen && node !== null && !isObserverStarted) {
            (_b = (_a = modalObserverRef.current) === null || _a === void 0 ? void 0 : _a.observe) === null || _b === void 0 ? void 0 : _b.call(_a, node);
            setObserverStarted(true);
        }
        else {
            (_d = (_c = modalObserverRef.current) === null || _c === void 0 ? void 0 : _c.disconnect) === null || _d === void 0 ? void 0 : _d.call(_c);
            setObserverStarted(false);
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isModalOpen]);
    return { isIntersectingViewport, dialogContentRef };
};
//# sourceMappingURL=useModalObserver.js.map